import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7608208c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-list" }
const _hoisted_2 = { class: "help-text" }
const _hoisted_3 = { class: "list-unstyled" }

import { computed, ref } from 'vue'
import { useUserStore } from '@/gp/UserStore'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { useDataGroupMemberStore } from '@/gp/DataGroupMemberStore'
import { usePersonStore } from '@/rd/PersonStore'
import { useTokenManager } from '@/auth/TokenManager'
import { DataGroupType, GroupMemberRole } from '@/gp/GroupAdminModel'
import { isDefined } from '@/util/TypeScriptUtil'
import { Person } from '@/rd/ResearchDataModel'
import { LoadMode } from '@/util/AsyncData'
import { usePageTitle } from '@/util/AppUtil'
import { PlusIcon } from '@zhuowenli/vue-feather-icons'
import ProfileCard from '@/manage/ProfileCard.vue'
import ProfileAddModal from './ProfileAddModal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileList',
  props: {
    userId: {}
  },
  setup(__props: any) {

const props = __props;



const profileAddModalRef = ref<InstanceType<typeof ProfileAddModal>>()

const userStore = useUserStore()
const dataGroupStore = useDataGroupStore()
const dataGroupMemberStore = useDataGroupMemberStore()
const personStore = usePersonStore()
const tokenManager = useTokenManager()

const userRef = computed(() => userStore.getAsyncUser(userIdRef.value, LoadMode.EnsureLoaded)?.data)
const profilePersonsRef = computed(() => {
  const ownerMembers = dataGroupMemberStore.getMembersForUsers([userIdRef.value], LoadMode.EnsureLoaded)
    .filter(dm => dm.role == GroupMemberRole.Owner && dm.groupType == DataGroupType.Profile)

  const personIds = dataGroupStore.getLoadedGroupList(ownerMembers.map(dm => dm.dataGroupId))
    .map(pg => pg.startItemId)

  // load persons so we can get them all at once AND sort them
  return personStore.getAsyncPersonList(personIds, LoadMode.EnsureLoaded)
    .map(a => a.data).filter(isDefined)
    .sort(Person.compareDisplayName)
})

const userIdRef = computed(() => props.userId ?? tokenManager.current.userId)
const isSelfRef = computed(() => userIdRef.value == tokenManager.current.userId)

usePageTitle("Managed Profiles", () => isSelfRef.value ? "" : userRef.value?.displayName)

function showAddProfileModal() {
  profileAddModalRef.value?.open()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (profilePersonsRef.value.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (isSelfRef.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" Profiles of living or recently living people that you manage. ")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" Profiles of living or recently living people that are managed by this user. ")
                ], 64))
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (isSelfRef.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("You do not manage any profiles.")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("This user does not manage any profiles that are visible to you.")
                ], 64))
          ], 64))
    ]),
    _createElementVNode("div", null, [
      (isSelfRef.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-primary btn-sm",
            onClick: showAddProfileModal
          }, [
            _createVNode(_unref(PlusIcon), {
              size: "1.2x",
              class: "mb-1"
            }),
            _createTextVNode(" Add a profile ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profilePersonsRef.value, (p) => {
        return (_openBlock(), _createElementBlock("li", {
          key: p.id
        }, [
          _createVNode(ProfileCard, {
            "person-id": p.id,
            "show-profile-type": ""
          }, null, 8, ["person-id"])
        ]))
      }), 128))
    ]),
    _createVNode(ProfileAddModal, {
      ref_key: "profileAddModalRef",
      ref: profileAddModalRef
    }, null, 512)
  ]))
}
}

})